import api from "./api";

// Capa de servicios API del dominio "flow builders" (flujos) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listFlowBuilders = (params) => api.get("/flowbuilders", { params });
export const getFlowBuilder = (id) => api.get(`/flowbuilders/${id}`);
export const createFlowBuilder = (payload) => api.post("/flowbuilders", payload);
export const updateFlowBuilder = (id, payload) =>
  api.put(`/flowbuilders/${id}`, payload);
export const deleteFlowBuilder = (id) => api.delete(`/flowbuilders/${id}`);

// Media (endpoint singular /flowbuilder/upload-media).
export const uploadFlowBuilderMedia = (formData) =>
  api.post("/flowbuilder/upload-media", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
